import React from 'react';
import { Box, FormControlLabel, Radio } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Icon } from '@alycecom/ui';

import { IAlyceCustomTheme } from '../../../../../styles/alyceTheme';
import { AddressOption } from '../../../store/shipping/shipping.types';

const useStyles = makeStyles<IAlyceCustomTheme, { isActive: boolean }>(({ palette, spacing }) => ({
  root: ({ isActive }) => ({
    borderRadius: 5,
    border: `solid 2px ${isActive ? palette.secondary.main : palette.grey.timberWolf}`,
    marginTop: spacing(1),
    padding: spacing(3),
  }),
  label: {
    width: '100%',
  },
  editLink: {
    fontSize: 12,
    fontFamily: 'Lato',
    fontWeight: 'bold',
    color: palette.link.main,
    width: 50,
    cursor: 'pointer',
  },
  icon: {
    marginRight: spacing(0.5),
  },
}));

export interface IAddressRadioOptionProps {
  label: React.ReactElement;
  value: AddressOption;
  isActive: boolean;
  onEdit?: () => void;
}

const AddressRadioOption = ({ label, value, isActive, onEdit }: IAddressRadioOptionProps): JSX.Element => {
  const classes = useStyles({ isActive });
  return (
    <Box className={classes.root}>
      <Box width={1} display="flex" justifyContent="space-between" alignItems="flex-end">
        <FormControlLabel className={classes.label} value={value} control={<Radio color="primary" />} label={label} />
        {onEdit && (
          <Box className={classes.editLink} onClick={onEdit}>
            <Icon className={classes.icon} icon="pencil" fontSize={0.8} />
            Edit
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AddressRadioOption;
